import React from 'react';
import Axios from 'axios';
import { cloneDeep } from "lodash";
import FlowContext from './context/FlowContext';

export default class WithFlowField extends React.Component {
    static contextType = FlowContext;

    constructor(props) {
        super(props);

        const { component, field, path } = this.props;
        this.component = component;
        this.field = field;
        this.path = path;

        this.updateFlow = () => { };
    }

    componentDidMount() {
        this.updateFlow = this.context.updateFlow;
    }

    updateValue = (value, callback = () => { }) => {
        this.updateFlow(
            this.path,
            (fieldValue) => {
                const field = cloneDeep(fieldValue);

                // Clear api errors on change
                field.errors.length = 0;

                // Set action
                field.action = 'change';

                field.value = value;

                return field;
            },
            this.field?.triggerUpdate,
            'change',
            callback,
        );
    }

    updateChoice = (choice, checked, callback = () => { }) => {
        this.updateFlow(
            this.path,
            (fieldValue) => {
                const field = cloneDeep(fieldValue);

                // Clear api errors on change
                field.errors.length = 0;

                // Set action
                field.action = 'change';

                if (checked) {
                    if (field?.multiple) {
                        field?.value?.push(choice?.key);
                    } else {
                        field.value = [choice?.key];
                    }
                } else {
                    const valueChoiceIndex = field?.value?.indexOf(choice?.key);
                    if (valueChoiceIndex >= 0) {
                        field?.value?.splice(valueChoiceIndex, 1);
                    }
                }

                return field;
            },
            this.field?.triggerUpdate,
            'change',
            callback,
        );
    }

    addFiles = (files, callback = () => { }) => {
        if (Array.from(files)?.length < 1) return callback();

        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append('upload[files][]', file);
        })
        formData.append('upload[name]', this.field?.name);
        formData.append('upload[component]', this.component?.id);

        Axios.post('/flows/files', formData, { headers: { "Content-Type": "multipart/form-data" } }).then((response) => {
            if (response?.data) {
                this.updateFlow(
                    this.path.split('.').slice(0, -2).join('.'),
                    (componentValue) => {
                        const component = cloneDeep(componentValue);

                        const field = component.fields.find((field) => field.name === this.field.name);

                        response?.data?.files?.forEach((file) => {
                            if (component.metadata[this.field.name]) {
                                component.metadata[this.field.name].push(file);
                            } else {
                                component.metadata[this.field.name] = [file];
                            }

                            field?.value?.push(file.id);
                        });

                        return component;
                    },
                    this.field?.triggerUpdate,
                    'change',
                    callback,
                );
            } else {
                return Promise.reject(new Error('no data'));
            }
        }).catch((error) => {
            throw new Error(error);
        });
    }

    removeFiles = (ids, callback = () => { }) => {
        if (ids?.length < 1) return callback();

        this.updateFlow(
            this.path.split('.').slice(0, -2).join('.'),
            (componentValue) => {
                const component = cloneDeep(componentValue);

                component.metadata[this.field.name] = component?.metadata?.[this.field.name]?.filter((file) => !ids?.includes(file.id));

                const field = component.fields.find((field) => field.name === this.field.name);

                field.value = field?.value?.filter((id) => !ids?.includes(id));

                return component;
            },
            this.field?.triggerUpdate,
            'change',
            () => {
                ids.forEach((id) => {
                    Axios.delete(`/flows/files/${id}/remove`).catch((error) => {
                        throw new Error(error);
                    });
                });

                callback();
            },
        );
    }

    render() {
        const { width } = this.field;
        const colClassName = `col-${width?.mobile} col-md-${width?.tablet} col-lg-${width?.desktop} col--flow-component-${this.component.name} col--flow-field-${this.field.type} col--flow-${this.field.name}`

        return (
            this.props.children({
                updateValue: this.updateValue,
                updateChoice: this.updateChoice,
                addFiles: this.addFiles,
                removeFiles: this.removeFiles,
                ...this.props,
                ...{ colClassName },
            })
        );
    }
}
